import {MP_SEARCH_REPORTS_COMPLETE} from '../actions/actionTypes';
import initialState from './initialState';

export default function update(state = initialState.reports, action) {
  if (action.type === MP_SEARCH_REPORTS_COMPLETE) {
    return action.payload.reports;
  } else {
    return state;
  }
}
